import React from 'react'

export default function DevelopedIcon(props) {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="-849 838 100 125"
      fill="currentColor"
      {...props}
    >
      <polygon points="-783.3,906.6 -777.7,901 -783.3,895.4 -780.5,892.6 -774.9,898.2 -772.1,901 -774.9,903.8 -780.5,909.4 " />
      <polygon points="-815.2,892.6 -820.8,898.2 -823.6,901 -820.8,903.8 -815.2,909.4 -812.4,906.6 -818,901 -812.4,895.4 " />
      <path
        d="M-800.9,862.1l-30.9,16.8c-2,1.1-3.3,3.2-3.3,5.5v33.1c0,2.3,1.3,4.4,3.3,5.5l30.9,16.8c1.9,1,4.1,1,6,0L-764,923
	c2-1.1,3.3-3.2,3.3-5.5v-33.1c0-2.3-1.3-4.4-3.3-5.5l-30.9-16.8C-796.7,861.1-799,861.1-800.9,862.1z M-767.3,921l-27.5,15
	c-1.9,1-4.1,1-6,0l-27.5-15c-2-1.1-3.3-3.2-3.3-5.5v-29.1c0-2.3,1.3-4.4,3.3-5.5l27.5-15c1.9-1,4.1-1,6,0l27.5,15
	c2,1.1,3.3,3.2,3.3,5.5v29.1C-764.1,917.8-765.3,919.9-767.3,921z"
      />
      <polygon points="-804,917.7 -788.2,886 -791.7,884.3 -807.5,916 " />
    </svg>
  )
}
